// extracted by mini-css-extract-plugin
export default {"historyContainer":"History_historyContainer__LR-JB","historyList":"History_historyList__Pd-jl"};